import React from 'react';
import { Translate } from 'core/translate';

const IncentivesMessage = ({ pricing, isSummary }) => {
  const { incentives, isSeeDealer } = pricing;

  if (!incentives.value || isSeeDealer || isSummary) {
    return null;
  }

  return (
    <div className="math-box__message">
      <Translate value="byo.page.general.disclaimer.msrp.notification" />
    </div>
  );
};

export default IncentivesMessage;
